/* RT accessibility pass 1 (Claude 2026-10-12), WCAG 2.2 AA. PREVIEW theme only until Sharon approves.
   Loaded deferred from layout/theme.liquid. Remove the one script tag to roll back.
   1. Links that open a new window say so (FAC para 47h, WCAG 3.2.5 advisory / G201).
   2. Collection filter group toggles get a real name and announce expanded/collapsed (FAC para 47j, WCAG 4.1.2).
   3. Judge.me reviews (2026-10-13): star summary is no longer an image wrapping a link (WCAG 4.1.2 nested-interactive);
      pagination arrows get real names ("Next page", not "Page 2"). Sizes live in rt-a11y.css.
   4. Landmarks (2026-10-14): announcement bar and newsletter band get named regions (WCAG 1.3.1).
   5. reCAPTCHA notice (2026-10-14): the floating badge is hidden in rt-a11y.css, so Google's required notice is
      shown under each Shopify form that reCAPTCHA protects (newsletter, contact, login, sign-up).
   6. Untitled third-party frames get a name (WCAG 4.1.2 frame-title), e.g. the VerifyPass discount widget. */
(function () {
  'use strict';
  var NEW_WIN = ' (opens in a new window)';

  function markNewWindowLinks(scope) {
    var links = scope.querySelectorAll('a[target="_blank"]:not([data-rt-nw])');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      a.setAttribute('data-rt-nw', '1');
      var rel = (a.getAttribute('rel') || '');
      if (rel.indexOf('noopener') === -1) a.setAttribute('rel', (rel + ' noopener').trim());
      var label = a.getAttribute('aria-label');
      if (label) {
        if (label.indexOf('new window') === -1) a.setAttribute('aria-label', label + NEW_WIN);
      } else {
        var s = document.createElement('span');
        s.className = 'rt-vh';
        s.textContent = NEW_WIN;
        a.appendChild(s);
      }
    }
  }

  function headingText(h, toggle) {
    var t = '';
    for (var i = 0; i < h.childNodes.length; i++) {
      var n = h.childNodes[i];
      if (n === toggle) continue;
      t += n.textContent || '';
    }
    return t.replace(/\s+/g, ' ').trim();
  }

  function syncToggle(h, a) {
    a.setAttribute('aria-expanded', h.classList.contains('toggle') ? 'true' : 'false');
  }

  function wireFilterToggles(scope) {
    var toggles = scope.querySelectorAll('.f8fl a.header-toggle:not([data-rt-tg])');
    for (var i = 0; i < toggles.length; i++) {
      (function (a) {
        var h = a.parentElement;
        if (!h || !/^H[1-6]$/.test(h.tagName)) return;
        var name = headingText(h, a);
        if (!name) return;
        a.setAttribute('data-rt-tg', '1');
        a.setAttribute('role', 'button');
        a.setAttribute('aria-label', name);
        syncToggle(h, a);
        new MutationObserver(function () { syncToggle(h, a); })
          .observe(h, { attributes: true, attributeFilter: ['class'] });
        a.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); a.click(); }
        });
      })(toggles[i]);
    }
  }

  var JDGM_ARROWS = { 'jdgm-paginate__first-page': 'First page', 'jdgm-paginate__prev-page': 'Previous page',
                      'jdgm-paginate__next-page': 'Next page', 'jdgm-paginate__last-page': 'Last page' };

  function fixJudgeMe(scope) {
    var sums = scope.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]');
    for (var i = 0; i < sums.length; i++) {
      var sum = sums[i];
      if (!sum.querySelector('a, button, [tabindex]')) continue;
      sum.removeAttribute('role');
      sum.removeAttribute('aria-label');
      var stars = sum.querySelectorAll('.jdgm-star');
      for (var j = 0; j < stars.length; j++) stars[j].setAttribute('aria-hidden', 'true');
    }
    for (var cls in JDGM_ARROWS) {
      var arrows = scope.querySelectorAll('.' + cls);
      for (var k = 0; k < arrows.length; k++) {
        var label = JDGM_ARROWS[cls];
        if (arrows[k].getAttribute('aria-label') !== label) arrows[k].setAttribute('aria-label', label);
      }
    }
  }

  var REGIONS = [['.shopify-section-announcement-bar-container', 'Announcements'], ['.rt-nl-section', 'Newsletter']];

  function labelRegions(scope) {
    for (var i = 0; i < REGIONS.length; i++) {
      var els = scope.querySelectorAll(REGIONS[i][0] + ':not([role])');
      for (var j = 0; j < els.length; j++) {
        els[j].setAttribute('role', 'region');
        els[j].setAttribute('aria-label', REGIONS[i][1]);
      }
    }
  }

  var RECAPTCHA_FORMS = ['customer', 'contact', 'customer_login', 'create_customer'];

  function addRecaptchaNotes(scope) {
    var inputs = scope.querySelectorAll('form input[name="form_type"]');
    for (var i = 0; i < inputs.length; i++) {
      var form = inputs[i].form;
      if (!form || form.getAttribute('data-rt-rc') || RECAPTCHA_FORMS.indexOf(inputs[i].value) === -1) continue;
      form.setAttribute('data-rt-rc', '1');
      var p = document.createElement('p');
      p.className = 'rt-recaptcha-note';
      p.innerHTML = 'This site is protected by reCAPTCHA and the Google ' +
        '<a href="https://policies.google.com/privacy">Privacy Policy</a> and ' +
        '<a href="https://policies.google.com/terms">Terms of Service</a> apply.';
      form.insertAdjacentElement('afterend', p);
    }
  }

  var FRAME_TITLES = [[/verifypass\.com/i, 'Verify your eligibility for a discount (VerifyPass)']];

  function titleFrames(scope) {
    var frames = scope.querySelectorAll('iframe:not([title])');
    for (var i = 0; i < frames.length; i++) {
      var src = frames[i].getAttribute('src') || '';
      for (var j = 0; j < FRAME_TITLES.length; j++) {
        if (FRAME_TITLES[j][0].test(src)) { frames[i].setAttribute('title', FRAME_TITLES[j][1]); break; }
      }
    }
  }

  function run(scope) {
    try { markNewWindowLinks(scope); } catch (e) {}
    try { wireFilterToggles(scope); } catch (e) {}
    try { fixJudgeMe(scope); } catch (e) {}
    try { labelRegions(scope); } catch (e) {}
    try { addRecaptchaNotes(scope); } catch (e) {}
    try { titleFrames(scope); } catch (e) {}
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(document); }, 250);
  }

  function init() {
    run(document);
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
